export default (kasko) => {
  kasko.addEventListener(
    'state-changed',
    (quote) => {
      if (!quote) return;

      kasko.dispatchEvent('set-form-input', {
        policy_end_date_human: quote.policy_end_date_human,
      });
      kasko.dispatchEvent('set-state-input', {
        policy_end_date_human: quote.policy_end_date_human,
      });
      kasko.dispatchEvent('set-state-input', {
        initial_policy_end_date: quote.initial_policy_end_date,
      });
      kasko.dispatchEvent('set-form-input', {
        initial_policy_end_date: quote.initial_policy_end_date,
      });
    },
    {
      slice: 'quote.data.extraData',
    },
  );
};
